import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cf-frontend-sdk-language-icon',
  templateUrl: './language-icon.component.html',
  styleUrls: ['./styles/language-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageIconComponent {
  /**
   * Provided language ID.
   */
  @Input() public set languageId(languageId: string) {
    this._languageId = languageId.toUpperCase();
  }

  public get languageId() {
    return this._languageId;
  }

  @HostBinding('class.cf-frontend-sdk-language-icon') public languageIcon = true;

  private _languageId = '';
}
